import React, {Component} from 'react';

// Assets
import goatArtwork from '../assets/artwork/GoatArtwork.png';

// Components
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import CtaBtn from '../components/CtaBtn';
import LinkBtn from '../components/LinkBtn';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';
import Testimonial from '../components/Testimonial';

// Utilities

class Home extends Component{
    state = {
        showModal: "none",
        displayMobile: "none"
      }

      toggleModal = () => {
        if (this.state.showModal === "none") {
            this.setState({
                showModal: "block"
            })
            window.scrollTo(0,0);
        }
        else {
            this.setState({
                showModal: "none"
            })
        }
        }

      toggleMobileMenu = () => {
        if (this.state.displayMobile == "none") {
            this.setState({
              displayMobile: "flex"
            })
        }
        else {
            this.setState({
              displayMobile: "none"
            })
        }
      }
      
      render() {
          return(
          <div className="HomePage">
          <Modal showModal={this.state.showModal} click={this.toggleModal}/>
          <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
          <div className="navbarNeighbor">
              <Hero click={this.toggleModal} />
              <Testimonial content='"Becky Sue Wehry’s vision and oversight of our website renovation more than doubled our traffic, increased our page views 5X, generated hundreds of new leads of impressive quality, and contributed to a significant amount in new business sales. She also streamlined our internal operations, redesigned marketing materials, served up wise suggestions and was artful in her pushbacks. She’s a wonderful person to work with."' name="Brian Palmer CMM," title="President of National Speakers Bureau" />
              <div className="homeCtaContainer flexRow">
                  <div className="homeCtaGoatWrap width-5">
                      <img src={goatArtwork} alt="Candid Goat"/>
                  </div>
                  <div className="homeCtaWrap width-7">
                      <h2 className="titleFont">Chewing Through Thick Tech</h2>
                      <p className="bodyFont">We create and manage your digital presence and processes.</p>
                      <p className="bodyFont">From your website to your sales funnel, we start with an honest, no BS conversation, and follow through with bite-sized chunks of real results until we get you where you need to be.</p>
                      <LinkBtn click="/services" name="Services" classes="subTitleFont bold"/>
                  </div>
              </div>
          </div>
          <footer>
              <Footer />
          </footer>
          </div>
        )}
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js